
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/[partner]",
      function () {
        return require("private-next-pages/partner/[partner].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/[partner]"])
      });
    }
  